import { TOKEN, REFRESH_TOKEN, SPYEE_TOKEN, SPYEE_REFRESH_TOKEN } from 'constants/index';

export function getAccessToken(): string | null {
    return window.TOTEM?.storage?.get?.(TOKEN) || null;
}

export function getRefreshToken(): string | null {
    return window.TOTEM?.storage?.get?.(REFRESH_TOKEN) || null;
}

export function setTokens(accessToken: string, refreshToken: string): void {
    window.TOTEM.storage.set(TOKEN, accessToken);
    window.TOTEM.storage.set(REFRESH_TOKEN, refreshToken);
}

export function clearTokens(): void {
    window.TOTEM.storage.remove(TOKEN);
    window.TOTEM.storage.remove(REFRESH_TOKEN);
    window.TOTEM.storage.remove(SPYEE_TOKEN);
    window.TOTEM.storage.remove(SPYEE_REFRESH_TOKEN);
}

export function isSpyeeMode(): boolean {
    return !!window.TOTEM?.storage?.get?.(SPYEE_TOKEN);
}

// Sortie du mode espion : seule la session du compte espionné est jetée, l'opérateur reste connecté.
export function clearSpyeeTokens(): void {
    window.TOTEM.storage.remove(SPYEE_TOKEN);
    window.TOTEM.storage.remove(SPYEE_REFRESH_TOKEN);
}

export function hasAccessToken(): boolean {
    return !!window.TOTEM?.storage?.get?.(TOKEN);
}

export function hasRefreshToken(): boolean {
    return !!window.TOTEM?.storage?.get?.(REFRESH_TOKEN);
}

// La session active : celle du compte espionné en mode espion (clés et en-tête à part), sinon celle de l'utilisateur.
export function getSessionTokens(): { access: string | null; refresh: string | null } {
    if (isSpyeeMode()) {
        return {
            access: window.TOTEM.storage.get(SPYEE_TOKEN) ?? null,
            refresh: window.TOTEM.storage.get(SPYEE_REFRESH_TOKEN) ?? null,
        };
    }
    return { access: getAccessToken(), refresh: getRefreshToken() };
}

export function setSessionTokens(accessToken: string, refreshToken: string): void {
    if (isSpyeeMode()) {
        window.TOTEM.storage.set(SPYEE_TOKEN, accessToken);
        window.TOTEM.storage.set(SPYEE_REFRESH_TOKEN, refreshToken);
        return;
    }
    setTokens(accessToken, refreshToken);
}

export function clearSessionTokens(): void {
    if (isSpyeeMode()) {
        clearSpyeeTokens();
        return;
    }
    clearTokens();
}
